import { EmptyState, Icon, type IconName } from "@go-novus/ui";

export interface InboxNoticeProps {
  body?: string;
  heading: string;
  iconName?: IconName;
}

/** 列表和回放的空态、加载中、失败都摆一句话，图标区分语气。 */
export function InboxNotice({
  body,
  heading,
  iconName = "inbox",
}: InboxNoticeProps) {
  return (
    <EmptyState body={body} heading={heading} icon={<Icon name={iconName} />} />
  );
}
